var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "admin-page-content" },
          [
            _c(
              "draggable",
              {
                staticClass: "drag-view",
                on: {
                  change: function($event) {
                    return _vm.changePosition()
                  }
                },
                model: {
                  value: _vm.leadershipList,
                  callback: function($$v) {
                    _vm.leadershipList = $$v
                  },
                  expression: "leadershipList"
                }
              },
              [
                _vm._l(_vm.leadershipList, function(text, index) {
                  return [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        text.video_path != ""
                          ? _c(
                              "span",
                              { staticClass: "btn edit-btn-vvg waves-effect" },
                              [
                                _c(
                                  "video",
                                  {
                                    attrs: {
                                      width: "250",
                                      controls: "controls",
                                      preload: "metadata"
                                    }
                                  },
                                  [
                                    _c("source", {
                                      attrs: {
                                        src: text.video_path + "#t=0.5",
                                        type: "video/mp4"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"
                                  },
                                  [_vm._v(" " + _vm._s(text.video_title) + " ")]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        text.video_url != ""
                          ? _c(
                              "span",
                              { staticClass: "btn edit-btn-vvg waves-effect" },
                              [
                                text.video_url != ""
                                  ? _c("iframe", {
                                      attrs: {
                                        src: text.video_url,
                                        controls: "",
                                        width: "250",
                                        height: "100"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"
                                  },
                                  [_vm._v(" " + _vm._s(text.video_title) + " ")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [
        _vm._v("\n                Draggable Image List\n            ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4295a12d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4295a12d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/leadershipdevelopment/ListLeadershipMedia.vue
// module id = null
// module chunks = 